// react
import React, { Suspense } from "react";

// components
import Spinner from "../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyIntegrations = React.lazy(() => import("./Main"));

const IntegrationsLazyLoader = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<LazyIntegrations />
		</Suspense>
	);
};

export default IntegrationsLazyLoader;
